<div>
  @if (!isLoading && !noData) {
    <div>
      <app-highcharts-generic
        [chartheight]="height"
        [options]="utilization_options"
        [series]="utilization_series"
      ></app-highcharts-generic>
    </div>
  }
</div>

@if (!isLoading && noData) {
  <div class="noDataZiti">No Data</div>
}
@if (isLoading) {
  <div style="margin-top: 9.375rem">
    <app-loader [isLoading]="isLoading"></app-loader>
  </div>
}
